import en from "./en/translation.json";
import ja from "./ja/translation.json";

const resources = {
  en: {
    translation: en
  },
  ja: {
    translation: ja
  }
};

export default resources;